import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';

const BRAND = 'Tesorería Scouts';

type PageTitleContextValue = {
  title: string | null;
  setTitle: React.Dispatch<React.SetStateAction<string | null>>;
};

const PageTitleContext = createContext<PageTitleContextValue | null>(null);

export function PageTitleProvider({ children }: { children: React.ReactNode }) {
  const [title, setTitle] = useState<string | null>(null);

  useEffect(() => {
    document.title = title ? `${BRAND} - ${title}` : BRAND;
  }, [title]);

  const value = useMemo(() => ({ title, setTitle }), [title]);
  return <PageTitleContext.Provider value={value}>{children}</PageTitleContext.Provider>;
}

export function useHeaderPageTitle() {
  return useContext(PageTitleContext)?.title ?? null;
}

/** Publica el título de la página en la barra superior (Tesorería Scouts - …). */
export function usePageTitle(title: string | null | undefined) {
  const setTitle = useContext(PageTitleContext)?.setTitle;

  useEffect(() => {
    if (!setTitle) return;
    const next = title?.trim() ? title.trim() : null;
    setTitle(next);
    return () => {
      setTitle((current) => (current === next ? null : current));
    };
  }, [setTitle, title]);
}
